import React from 'react';
import Input from '../ShareholderDetails/Input';
import { TStep3Branch, TStep3Info } from '../../../types';

type TProps = {
  branches: any;
};
const AddressesOfBusiness = ({ branches }: TProps) => {
  return (
    <div className='my-5'>
      <div className='text-[13px] font-[600] text-[#028789] mb-4'>Organization Address</div>

      <div className='sl:flex justify-between flex-wrap gap-[4%]'>
        <Input
          label={`Organization Address`}
          value={`${branches?.streetNumber}, ${branches?.streetName}, ${branches?.selectedLga}, ${branches?.selectedState}`}
          style='sl:w-[30%] grow'
          readonly
        />

        <Input
          label={'Nearest Sterling Bank Branch'}
          value={branches?.nearestSterlingBranch}
          style='sl:w-[30%]'
          readonly
        />
      </div>
    </div>
  );
};

export default AddressesOfBusiness;
